import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';
import type { useHomeWidgetStateQuery$data } from './__generated__/useHomeWidgetStateQuery.graphql.ts';
import { preloadHomeWidgets } from './preloadHomeWidgets.ts';

export const preloadSidePanel = ({
	isLicensed,
}: {
	isLicensed: boolean;
}):
	| Promise<void>
	| Promise<{
			data: useHomeWidgetStateQuery$data | null;
			errors?: ReadonlyArray<GraphQLErrorInterop>;
			hasErrors: boolean;
	  }> => {
	return preloadHomeWidgets({ isLicensed });
};
